import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import {
  IAPI_FAC002_Request,
  IAPI_FAC002_Response,
} from "../../../type/apiType";
import {
  IAPI_FAC036_Request,
  IAPI_FAC036_Response,
} from "../../../type/apiType";

// 共済契約対象施設等一部廃止届一覧参照
const httpIAPI_FAC002 = async (
  param: IAPI_FAC002_Request
): Promise<IAPI_FAC002_Response> => {
  let res = await http.post(ApiUrl.API_FAC002, {
    ...param,
  });
  return res.data;
};

// 共済契約対象施設等一部廃止届一括更新API
const httpIAPI_FAC036 = async (
  param: IAPI_FAC036_Request
): Promise<IAPI_FAC036_Response> => {
  let res = await http.post(ApiUrl.API_FAC036, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_FAC002, httpIAPI_FAC036 };
